import {
  IBaseMigrationSterilisationEquipment,
  SterilisationEquipmentMappingHandler,
} from '../../../mappings/sterilisation-equipment';
import {
  D4WSterilisationPack,
  ID4WSterilisationPack,
  SterilisationPackSourceEntity,
} from '../../source/entities/sterilisation-packs';

export class D4WSterilisationEquipmentMappingHandler extends SterilisationEquipmentMappingHandler<
  D4WSterilisationPack,
  SterilisationPackSourceEntity
> {
  sourceEntity = new SterilisationPackSourceEntity();

  translateFn = (
    record: ID4WSterilisationPack
  ): IBaseMigrationSterilisationEquipment => ({
    id: record.id,
    name: record.contents,
  });
}
